import React, { useContext, useEffect, useState } from 'react'
import { observer } from 'mobx-react'
import './index.scss'
import { NavLink, useNavigate, useParams } from 'react-router'
import { StoresContext } from '@App/contexts'
import SettingPassword from '@Scenes/UserRegistrationScenes/CreatePasswordScene/CreatePasswordForm'
import ConfigurationMFA from '@Scenes/UserRegistrationScenes/CreatePasswordScene/ConfigurationMFA'
import ConfirmSMSCode from '@Scenes/UserRegistrationScenes/CreatePasswordScene/ConfirmSMSCode'
import { CreatePasswordStatus } from '@App/enum/create-password-status'
import Navigation from '@App/navigation'
import PointPreloader from '@Components/Preloaders/PointPreloader'
import { analyticsSendPage } from '@App/common/utils/analytics-utils'
import { PARAM } from '@App/navigation/param'

export interface CreatePasswordSceneChildrenProps {
    loading: boolean
    setLoading: (loading: boolean) => void
}

const CreatePasswordScene = () => {
    const params = useParams<typeof PARAM>()
    const navigate = useNavigate()
    const { createPasswordStore, popupStore } = useContext(StoresContext)
    const [loading, setLoading] = useState<boolean>(false)

    const activateUser = async () => {
        const activatingCode = params.activatingCode
        if (!activatingCode) {
            return
        }
        try {
            setLoading(true)
            await createPasswordStore.activateUser(activatingCode)
        } catch (error) {
            popupStore.setAlertFromError(error)
            navigate(Navigation.login.root())
        }
        setLoading(false)
    }

    useEffect(() => {
        analyticsSendPage('create_password')
        activateUser().then()
    }, [])

    return (
        <>
            <title>Create password</title>
            <main className="create-password-scene">
                {loading && <PointPreloader />}
                {!loading && createPasswordStore.createPasswordStatus === CreatePasswordStatus.setting_password && (
                    <SettingPassword loading={loading} setLoading={setLoading} />
                )}
                {!loading && createPasswordStore.createPasswordStatus === CreatePasswordStatus.configuration_mfa && (
                    <ConfigurationMFA loading={loading} setLoading={setLoading} />
                )}
                {!loading && createPasswordStore.createPasswordStatus === CreatePasswordStatus.confirm_sms_code && (
                    <ConfirmSMSCode loading={loading} setLoading={setLoading} />
                )}
                {!loading && createPasswordStore.createPasswordStatus === CreatePasswordStatus.config_done && (
                    <div className="global-container">
                        <div className="after-create-pass">
                            <h3>Password set!</h3>
                            <p>Your personal user account password has been set successfully.</p>
                            <NavLink to="/login">Go to Portal</NavLink>
                        </div>
                    </div>
                )}
            </main>
        </>
    )
}

export default observer(CreatePasswordScene)
